export default "__VITE_ASSET__DIv14Me2__"